<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <span>{{ $route.name }}</span>
      </div>
      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-input
                placeholder="请输入从业人员"
                v-model="form.name"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select
                v-model="form.org_id"
                clearable
                filterable
                placeholder="请选择机构"
              >
                <el-option
                  v-for="item in orgList"
                  :key="item.org_id"
                  :label="item.org_name"
                  :value="item.org_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select
                v-model="form.status"
                placeholder="请选择账号状态"
                clearable
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" style="float: right">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="name"
            label="名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="org_name"
            label="机构名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="country"
            label="国籍"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="employ_method"
            label="聘用方式"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="source"
            label="来源"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="record"
            label="教育局备案状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.record === '未备案' ? 'red' : '#4991e1',
                  }"
                >
                  {{ scope.row.record }}
                </span>
              </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.status | statusFilter }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="createtime"
            label="时间"
            width="150px"
          >
            <template slot-scope="scope">
              {{ scope.row.createtime .substring(0, scope.row.createtime.length - 3)}}
            </template>
          </el-table-column> -->
          <el-table-column
            width="200"
            label="操作"
            fixed="right"
            align="center"
          >
            <template slot-scope="scope">
              <!-- <el-button type="text" @click="toDetail(scope)">查看</el-button> -->
               <el-button v-if="scope.row.status==3" type="text" @click="setStatus(scope.row.user_id,'1')"
                >解锁</el-button
              >
              <el-button v-if="scope.row.status!=3" type="text" @click="setStatus(scope.row.user_id,'3')"
                >锁定</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
    <!-- <Add :info.sync="detail.info" v-show="addShow" @to-index="toIndex"></Add> -->
  </div>
</template>

<script>
import dayJs from "dayjs";
import {
  getAllUserList,
  setUserStatus,
  getOrgList,
  getOrgQYList,
} from "@/api/user/userCenter";
export default {
  components: {
    Detail: () => import("../orginManagement/detail.vue"),
  },
  data() {
    return {
      form: {
        name: "",
        status: "",
        org_name: "",
        org_id: "",
      },
      orgId: "",
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      addShow: false,
      statusList: [
        { id: "0", label: "未激活  ", value: "0" },
        { id: "1", label: "正常    ", value: "1" },
        { id: "2", label: "注销    ", value: "2" },
        { id: "3", label: "锁定    ", value: "3" },
        { id: "4", label: "安管锁定", value: "4" },
        { id: "5", label: "空间封锁", value: "5" },
      ],
      orgList: [],
    };
  },
  mounted() {},
  created() {
    this.getDataList("created");
    this.initData();
  },
  filters: {
    statusFilter(type) {
      const typeMap = {
        0: "未激活   ",
        1: "正常    ",
        2: "注销    ",
        3: "锁定    ",
        4: "安管锁定",
        5: "空间封锁",
      };
      return typeMap[type];
    },
    genderFilter(type) {
      const typeMap = {
        0: "女",
        1: "男",
        2: "保密",
      };
      return typeMap[type];
    },
  },
  methods: {
    async initData() {
      let isPlatform =
        JSON.parse(window.sessionStorage.getItem("userInfo"))
          .v_platform_code ===
          JSON.parse(window.sessionStorage.getItem("userInfo")).platform_code ||
        JSON.parse(
          window.sessionStorage.getItem("userInfo")
        ).v_platform_code.includes(",");
      let params = {
        // org_id:sessionStorage.getItem("orgId")||'', //	机构、学校等组织id
        org_name: this.form.org_name, //	机构、学校等组织名称
        org_type: "8", //	组织类型，多个使用英文逗号分隔(1机构，2学校，8企业，9教学工作室，10平台)
        province_code: "", //	所属地理省份
        city_code: "", //	所属地理市
        area_code: "", //	所属地理区
        status: "", //       	状态,多个使用英文逗号分隔(0:组织未激活,1:正常)
        // platform_code:'',
        // v_platform_code:'',
        platform_code: isPlatform ? sessionStorage.getItem("platformCode") : "", //	实体平台编码
        v_platform_code: isPlatform
          ? ""
          : JSON.parse(window.sessionStorage.getItem("userInfo"))
              .v_platform_code, //	虚拟平台编码
        certification: "", //	认证(0:未认证,1:已认证)
        org_category: "", //	组织的类别(见文档十三.4，每个类型的组织都有自己的类别)
        org_level_code: "", //	行政区划(行政上所属的区域)
        org_parent_id: "", //	上级机构id(查的是直属下级单位)
        org_parent_ids: sessionStorage.getItem("orgid_top") || "", //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
        flag: "", //	         标记,多个使用英文逗号分隔,默认正常和演示(0:正常,1:演示,2:测试)
        page: 1, //	查询页
        page_size: 9999, //	查询条数，默认10，上限100
        is_more: "0", //	返回更多信息(0:否,1:是)
        // org_record_status:this.queryParams.org_record_status,// 教育局备案状态
        more_field: [
          "org_record_status",
          "school_legal_person_name",
          "org_code_certificate",
          "org_address",
          "org_telephone",
          "org_social_credit_code",
          "status",
          "org_source_level",
        ], //	指定返回的字段名称,传入看示例, //	指定返回的字段名称,传入看示例
        sort: "time", //按时间排序
      };
      var { code, result } = await getOrgList(params);
      if (code === "000000") {
        this.orgList = result.lists;
      }
    },
    async getDataList(type) {
      var orgId ;
      if (type == "search") {
        orgId = this.form.org_id==''?sessionStorage.getItem("orgIdGrop"):this.form.org_id;
      } else {
        orgId = sessionStorage.getItem("orgIdGrop") || "";
      }
        let isPlatform =
        JSON.parse(window.sessionStorage.getItem("userInfo"))
          .v_platform_code ===
          JSON.parse(window.sessionStorage.getItem("userInfo")).platform_code ||
        JSON.parse(
          window.sessionStorage.getItem("userInfo")
        ).v_platform_code.includes(",");

      let params = {
        org_id: orgId,
        user_type: "", //  （user_type: 0:学生,1:教师,2:家长）不传时查平台所有用户类型
        keyword: this.form.name, //	名字模糊搜索
        province_code: "", //	省级code
        city_code: "", //	市级code
        area_code: "", //	区级code
        school_period: "", //  教师主教学段（0小学、1初中、2高中详见文档十三.9）
        subject_id: "", //	教师主教学科id
        page: this.page.pageNum, //  页码
        page_size: this.page.pageSize, //  每页条数，默认20，最大50
        order_by: "", //  1是按昨日空间访问量排序，0默认按访问量排序
        school_id: "", //	学校id，显示老师列表信息
        class_id: "", //	班级id，显示学生信息。与school_id两者传其一
        vocational_edu: "", //  是否查询职教的学校，1：是
        flag: "", //  标记(0:正常,1:演示,2:测试)
        // platform_code: "", //	实体平台编码
        // v_platform_code: "", //	虚拟平台编码
         platform_code: isPlatform ? sessionStorage.getItem("platformCode") : "", //	实体平台编码
        v_platform_code: isPlatform
          ? ""
          : JSON.parse(window.sessionStorage.getItem("userInfo"))
              .v_platform_code, //	虚拟平台编码
        badge: "", //	徽章代码，多个逗号分隔
        honorary_id: "", //	荣誉id
        console_admin_group_source: "", //	按区域管理角色
        system_id: "", //	体系id (1:省级培训讲师)
        role_id: "", //	角色id (默认角色岗位)
        period_type: "", //	学段类型字符串 多个以,连接
        status: this.form.status,
        org_name: this.form.org_name,
        // org_parent_ids: sessionStorage.getItem("orgId")||'', //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
      };
      var { code, result } = await getAllUserList(params);
      if (code == "000000") {
        this.tableData = result.list;
        this.page.totalPage = result.count;
      }
      // var orgId=''
      // if(type=='created'){
      //   orgId= sessionStorage.getItem("orgId") ||''
      // }else{
      //   orgId=this.form.org_id
      // }
      // let params = {
      //   top_org_id: orgId ||sessionStorage.getItem("orgId"),
      //   org_id:orgId,
      //   org_recursion: "0", //是否包含下级节点成员，0:不包含（默认），1:包含所有下级，org_id须为单值
      //   top_school_id: "", 
      //   name: this.form.name,
      //   page: this.page.pageNum,
      //   page_size: this.page.pageSize,
      //   status: '', //用户状态(0:未激活, 1:正常, 2:注销, 3:锁定, 4:安管锁定,5空间封锁)，多个用”,”分割）
      // };
      // var { code, result } = await getOrgQYList(params);
      // console.log("企业获取在职人员列表---",params,result.member_list);
      // if (code == "000000") {
      //   this.tableData = result.member_list;
      //   this.page.totalPage = result.count;
      // }
    },
    add() {
      this.addShow = true;
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList("search");
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
      // console.log('999999999');
      this.detail.info = scope.row;
      this.detail.show = true;
    },
    async setStatus(userId,status) {
      let params = {
        usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
        user_id: userId,
        status: status, //0:未激活, 1:正常, 2:注销, 3:成员锁定, 4:安管锁定,5:空间封锁）
      };
      var { code, message } = await setUserStatus(params);
      if (code == "000000") {
        this.page.pageNum = 1;
        this.getDataList();
        this.$message({
          type: "success",
          message: "操作成功",
        });
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
    },
    filterTime(time) {
      return new Date(parseInt(time) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    },
    toIndex() {
      this.detail.show = false;
      this.addShow = false;
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 170px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
